var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWedelivercolor4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2C3.5 1.17031 2.82969 0.5 2 0.5C1.17031 0.5 0.5 1.17031 0.5 2V17.75C0.5 19.8219 2.17812 21.5 4.25 21.5H23C23.8297 21.5 24.5 20.8297 24.5 20C24.5 19.1703 23.8297 18.5 23 18.5H4.25C3.8375 18.5 3.5 18.1625 3.5 17.75V2ZM22.5594 6.05938C23.1453 5.47344 23.1453 4.52188 22.5594 3.93594C21.9734 3.35 21.0219 3.35 20.4359 3.93594L15.5 8.87656L12.8094 6.18594C12.2234 5.6 11.2719 5.6 10.6859 6.18594L5.43594 11.4359C4.85 12.0219 4.85 12.9734 5.43594 13.5594C6.02188 14.1453 6.97344 14.1453 7.55938 13.5594L11.75 9.37344L14.4406 12.0641C15.0266 12.65 15.9781 12.65 16.5641 12.0641L22.5641 6.06406L22.5594 6.05938Z",
    fill: "#DC2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedelivercolor4);
export default __webpack_public_path__ + "static/media/wedelivercolor4.84467f9195bd2c5e2ae7dc02b2ee21a6.svg";
export { ForwardRef as ReactComponent };